import React, { useEffect, useState, useCallback} from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { editList, getList, deleteList } from 'api/lists';
//components
import Title from 'components/backoffice/texts/title';
import ListForm from 'components/backoffice/forms/listForm';

const EditList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['backoffice']);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [list, setList] = useState([]);
  const { setTitle } = useOutletContext()

  const getDetailList = async () => {
    const { data, status } = await getList(id);
    if (status === 200) {
      setList(data);
    } else {
      setList([]);
    }
  };

  useEffect(() => {
    getDetailList();
  }, []);

  useEffect(() => {
    if(list){
      setTitle(t('edit', {title: list?.nombre}))
    }
    return () => {
      setTitle('');
    };
  },[list, setTitle])

  const onSubmit = async (values) => {
    setLoading(true)
    try {
      const payload = {
        nombre: values.nombre,
        nombre_fr: values.nombre_fr,
        nombre_ca: values.nombre_ca,
        nombre_eu: values.nombre_eu,
        nombre_en: values.nombre_en,
        nombre_gl: values.nombre_gl,
        tipo: values.tipo,
        contenido: values.contenido,
        estado: values.estado,
        location_web: values.location_web,
        order: values.order === '' || values.order == null ? 0 : values.order,
        producto_ids: values.products.map((item) => item.id),
      };
      const { status } = await editList(payload, id);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/lists', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
      setLoading(false)
    } catch (error) {
      console.error('Error en onCreate:', error);
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteList(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/lists', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);

  return (
    <div>
      <Title text={t('editlist')} />
      <ListForm 
        loading={loading} 
        isEditing={true} 
        onSubmitForm={onSubmit} 
        openModalDelete={openModalDelete} 
        setOpenModalDelete={setOpenModalDelete} 
        defaultValues={list} 
        onDelete={handleDelete} 
        id={id} 
      />
    </div>
  );
};

export default EditList;
